<main class="flex items-center justify-center overflow-hidden w-full h-screen bg-gray-50">
  @if (!fullscreen()) {
    <section class="h-full w-0 lg:w-auto">
      <ng-content select="[menu]" />
    </section>
  }

  <section class="flex flex-col h-full flex-1 overflow-hidden min-w-0">
    @if (!fullscreen()) {
      <div class="box-border flex h-12 w-full shrink-0 justify-center border-b border-primary-100">
        <div class="flex h-full w-full max-w-[1920px] items-center">
          <ng-content select="[header]" />
        </div>
      </div>
    }

    <div class="flex justify-center flex-1 overflow-hidden">
      <div [ngClass]="fullscreen() ? 'w-full h-full min-h-0 overflow-hidden' : 'max-w-[1920px] min-h-0 min-w-0 max-h-full w-full overflow-hidden'">
        <ng-content select="router-outlet" />
      </div>
    </div>
  </section>
</main>
